export default "__VITE_ASSET__CEKKYgtD__"